import { dictionaryService } from "../../../dataFlow";
import { useDictionaryItem, useParameter } from "../../../shared";
import { SLIDE_NUMBER } from "../constants";

export function useSlideTitle() {
  const [commodityId] = useParameter<number>('@commodities_display');
  const [businessUnit] = useParameter<number>('@business-units');
  const [_, commodityName] = useDictionaryItem(dictionaryService, "slides-commodities-display", commodityId, {
    business_unit: businessUnit,
    slide: SLIDE_NUMBER,
  });
  const title = commodityName && `Fruits prices by lead countries – ${(commodityName as any)[9]} producer prices and consumption/capita`;
  return title || '';
}